module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/01945dc4cf53ee657ed375f50d2c483a.png";